import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateChild,
  RouterStateSnapshot
} from '@angular/router';
import { Platform } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { UiHelperService } from '../../core/ui-helper.service';
import { AppLaunchable, UrlHelper } from '../../helpers/url-helper.service';

@Injectable({
  providedIn: 'root'
})
export class AppBlockGuard implements CanActivateChild {
  private isAppBlocked = false;

  constructor(
    private platform: Platform,
    private ui: UiHelperService,
    private trans: TranslateService,
    private urlHelper: UrlHelper
  ) {}

  block() {
    this.isAppBlocked = true;
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (!this.platform.is('cordova')) { return true; }
    if (!this.isAppBlocked) { return true; }

    this.openAppBlockedDialog();
    return false;
  }

  private openAppBlockedDialog() {
    this.ui.presentCustomAlertModalInfo(
      this.trans.instant('APP_BLOCKED.TEXT'),
      this.trans.instant('APP_BLOCKED.TITLE'),
      () => {
        this.urlHelper.openMarket(AppLaunchable.MAPFRE);
        return false;
      },
      this.trans.instant('APP_BLOCKED.ACCEPT')
    );
  }
}
